import { render, staticRenderFns } from "./DailyRegistered.vue?vue&type=template&id=def21bc8"
import script from "./DailyRegistered.vue?vue&type=script&lang=js"
export * from "./DailyRegistered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports